/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  PauseCampaignMutationResponse,
  PauseCampaignPathParams,
} from '../types/PauseCampaign'

function getPauseCampaignUrl({
  bison_campaign_id,
}: {
  bison_campaign_id: PauseCampaignPathParams['bison_campaign_id']
}) {
  const res = {
    method: 'POST',
    url: `/api/v1/emailbison/campaigns/${bison_campaign_id}/pause/` as const,
  }
  return res
}

/**
 * @description Pause a running campaign.
 * This stops an active campaign from sending emails.
 * @summary Pause a running campaign
 * {@link /api/v1/emailbison/campaigns/:bison_campaign_id/pause/}
 */
export async function pauseCampaign(
  {
    bison_campaign_id,
  }: { bison_campaign_id: PauseCampaignPathParams['bison_campaign_id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    PauseCampaignMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'POST',
    url: getPauseCampaignUrl({ bison_campaign_id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
